<template>
  <div>
    <h4>Types</h4>

    <el-select v-model="value"
               @change="handleSelect">
      <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { typeTag } from '@meta/widget/templates'

export default {
  name: 'TypesFilter',
  data() {
    return {
      options: [
        {
          value: 'all',
          label: 'All Types',
        },
        {
          value: typeTag.GAMIFICATION,
          label: 'Gamification',
        }, {
          value: typeTag.POPUP,
          label: 'Popup',
        }, {
          value: typeTag.FLYOUT,
          label: 'Flyout',
        }],
      value: 'all',
    }
  },
  methods: {
    handleSelect() {
      this.$emit('type-select', this.value)
    },
  },
}
</script>